import config from '@iotv/config';
import ApiGateway from '../../data/aws/api-gateway/ApiGateway';
import { ConsumerDao } from '../../data/ConsumerDAO';
import { DevicePoolType } from '../../types/AppTypes';
const debug = process.env.REACT_APP_DEBUG && false;
const dyn = config.aws.dynamoDB;
export const listDevices = async (fn, contextRequest) => {
    debug && console.log('listDevices', contextRequest);
    //TODO: Move devicePoolType into parameter
    const devicePoolType = DevicePoolType.INVENTORY;
    const apiRef = 'SystemManagementApi';
    const urlPart = devicePoolType === DevicePoolType.INVENTORY ? 'listInventoryDevices' : devicePoolType === DevicePoolType.ALLOCATION ? 'listAllocatedDevices' : null;
    if (urlPart) {
        try {
            const response = await ApiGateway.post(`/system/Device/${urlPart}`, contextRequest, apiRef);
            debug && console.log('Diagnostic View device query results', response);
            fn(response);
        }
        catch (e) {
            debug && console.log('Error in UM query', e);
        }
    }
};
export const getDeviceTransactionQueryParams = (deviceSk, Limit = 5) => {
    return getDeviceTransactionQueryParamsV2({ deviceSk, Limit });
};
export const getDeviceTransactionQueryParamsV2 = ({ Limit, deviceSk, broadcastScheduleSk }) => {
    const params = {
        TableName: dyn.tableName,
        IndexName: dyn.tsiName,
        ExclusiveStartKey: undefined,
        ExpressionAttributeNames: {
            '#pk': dyn.pKey,
            '#sk': dyn.sKey,
        },
        ExpressionAttributeValues: {
            ':pk': deviceSk,
            ':type': 'DeviceControlTransaction',
        },
        ScanIndexForward: false,
        Limit,
        KeyConditionExpression: '#pk = :pk',
        FilterExpression: `begins_with( #sk, :type)`,
    };
    if (broadcastScheduleSk) {
        ;
        (params.ExpressionAttributeNames['#broadcastScheduleSk'] = 'broadcastScheduleSk'),
            (params.ExpressionAttributeValues[':broadcastScheduleSk'] = broadcastScheduleSk),
            (params.FilterExpression += ` and #broadcastScheduleSk = :broadcastScheduleSk`);
    }
    return params;
};
export const getNetworkQueryResults = async (setterFn, params) => {
    const res = await ConsumerDao.baseQuery(params);
    setterFn(res);
    return res;
};
export const putItem = async (deviceControlTransaction) => {
    try {
        const response = await ApiGateway.post('/putItems/', deviceControlTransaction, 'ConsumerApi');
        // if (response.data?.Items) {
        //   console.log("insert successfully");
        // }
        return response;
        // debug && console.log("results", response);
    }
    catch (e) {
        debug && console.log('Error in sending device request', e);
    }
};
